import en from './en';
import ro from './ro';
import ru from './ru';

export const dictionary = {
  en: en,
  ro: ro,
  ru: ru,
} as TranslationType;

/**
 * Use only en json as default type for others
 */
export type TranslationKey = typeof en;
export type TranslationKeys = keyof TranslationKey;
type TranslationType = {[x: string]: TranslationKey};

export type TranslationFunction = (term: TranslationKeys) => string;
